import { j as o } from "./atoms-v218.js";
import { createContext as n, useState as l, useMemo as u } from "react";
const d = n({
  isDebugging: !1,
  isGridVisible: !0,
  setIsGridVisible: () => {
  }
}), p = ({ children: s, debug: e = !1 }) => {
  const [i, r] = l(!0), t = u(
    () => ({
      isDebugging: e,
      isGridVisible: i,
      setIsGridVisible: r
    }),
    [e, i]
  );
  return /* @__PURE__ */ o.jsx(d.Provider, { value: t, children: s });
};
export {
  d as GridHelperContext,
  p as GridHelperProvider
};
